/* eslint-disable @typescript-eslint/no-unused-vars */

(function (angular) {
  angular.module('xplenty-designer').directive('designerNote', [
    function () {
      return {
        templateNamespace: 'svg',
        restrict: 'E',
        // eslint-disable-next-line global-require
        template: require('./designer-note.html'),
        replace: true,
        link(scope, element, attrs) {
          scope.note.setElement(element);

          scope.$on('$destroy', function () {
            scope.note.destroy();
          });
        },
      };
    },
  ]);
})(window.angular);
